import { Common, color } from '@stockbit/ui';
import { Skeleton } from 'antd';
import styled, { css } from 'styled-components';

const { Flex, Modal: SbModal } = Common;

export const CompanyLabelContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  & > div {
    margin-left: 5px;
  }
`;

export const DataField = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  line-height: normal;

  &.border-bottom {
    border-bottom: 1px solid #ededed;
  }

  .ant-progress-inner:not(.ant-progress-circle-gradient)
    .ant-progress-circle-path {
    stroke: ${color.primary};
  }

  .free-transfer {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 19px;
    color: #00ab6b;
  }
`;

const BaseContainerStyle = css`
  border: 1px solid ${color.downgray};
  border-radius: 4px;
`;

export const BaseContainer = styled.div`
  ${BaseContainerStyle};
  margin-bottom: 0;
`;

export const TableContainer = styled.fieldset`
  padding: 16px 20px;
  row-gap: 14px;
  display: flex;
  flex-direction: column;

  ${BaseContainerStyle};

  legend {
    font-size: 14px;
    font-family: var(--bold-font);
    line-height: normal;
    padding: 0 10px;
    width: auto;
    margin-bottom: 0px;
    margin-left: -10px;
    text-transform: capitalize;
  }

  & > div {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CompanyCard = styled(Flex)`
  padding: 16px 20px;
  ${BaseContainerStyle};
`;

export const SymbolAvatar = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  background: #3a645c;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const LabelWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  border: 1px solid ${color.primary};
  border-radius: 4px;
  padding: 2px 4.5px 2px 2px;
`;

export const LabelDayTrade = styled(LabelWrapper)`
  border: 1px solid #8277f8;
  font-size: 12px;
  font-weight: 700;
  color: #8277f8;
  display: flex;
  background-color: #f5f0ff;
`;

export const Modal = styled(SbModal)`
  & > .ant-modal-content {
    border-radius: 3px;
  }

  & .ant-modal-close-x {
    font-size: 11px;
  }
`;

export const HeaderWrapper = styled.div`
  padding: 20px 20px 0;
`;

export const ContentWrapper = styled.div`
  padding: 20px;

  & > * {
    margin-bottom: 16px;

    &:last-child {
      margin: 0;
    }
  }
`;

// Company

export const CompanyTextSkeleton = styled(Skeleton)`
  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {
    margin: 0;
  }

  .ant-skeleton-title {
    margin: 0 0 8px;
  }
`;

export const CompanyButton = styled.button`
  background: none;
  border: none;
  outline: none;
  width: 100%;
  padding: 0;
`;

export const CompanySkeletonBlock = styled(Skeleton.Button).attrs({
  active: true,
})`
  display: block;

  & > .ant-skeleton-button {
    border-radius: 4px;
    height: 74px;
    width: 100%;
  }
`;
